import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { fetchViewerProfileQuery } from "../../behavior/api/viewer";
import { Heading } from "../../components/elements";
import Header from "../../components/header/Header";
import { ChangePassword, YourDetails } from "../../components/yourProfile";
import "./YourProfile.css";

const YourProfile = () => {
    const { t } = useTranslation();
    const {
        data: viewer,
        isLoading: loading,
        refetch,
    } = useQuery({
        queryKey: ["viewer", "profile"],
        queryFn: fetchViewerProfileQuery(),
    });

    const refetchData = async () => {
        await refetch();
    };

    const exists = viewer?.providerData?.find((x) => x.providerId === "password");
    const existingPassword = !!exists;
    const primaryProvider = !exists && viewer?.providerData?.[0] ? viewer.providerData[0].providerId : "";

    return (
        <>
            <Header type="LoggedIn" />
            <div className="your-profile-wrapper">
                <Heading level="h2">{t("MyProfile.Title")}</Heading>
                <div className="column-wrapper">
                    <YourDetails viewer={viewer} loading={loading} />
                    <ChangePassword
                        existingPassword={existingPassword}
                        primaryProvider={primaryProvider}
                        loading={loading}
                        refetch={refetchData}
                    />
                </div>
            </div>
        </>
    );
};

export default YourProfile;
